/**
 * states.js
 */

export const TOAST_STATE_ASK = 'state-ask';
export const TOAST_STATE_NPS = 'state-nps';
export const TOAST_STATE_FORM = 'state-form';
export const TOAST_STATE_FORM_AGREE = 'state-form-agree';
export const TOAST_STATE_FORM_DISAGREE = 'state-form-disagree';
export const TOAST_STATE_COMPLETED = 'state-completed';
export const TOAST_STATE_DECLINED = 'state-declined';
export const TOAST_STATE_SHOWN = 'state-shown';



// WEBPACK FOOTER //
// ./src/components/SurveyToast/states.js